import React from 'react';
import BlogCard from './BlogCard';
import { SkeletonBlogCard } from '../SkeletonLoader';
import './BlogList.css';

const BlogList = ({ posts, loading, error }) => {
  if (loading) {
    return (
      <div className="blog-list">
        <div className="blog-list-grid">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <SkeletonBlogCard key={i} />
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-list-error">
        <p>Error loading blog posts. Please try again later.</p>
      </div>
    );
  }

  if (!posts || posts.length === 0) {
    return (
      <div className="blog-list-empty">
        <p>No blog posts found.</p>
        <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '12px', lineHeight: '1.6' }}>
          {!loading && !error && (
            <>
              This is normal if you haven't added any posts yet.<br/>
              To add blog posts, go to Firebase Console → Firestore Database → Create collection "blogPosts"<br/>
              See <strong>TROUBLESHOOTING.md</strong> for detailed instructions.
            </>
          )}
        </p>
      </div>
    );
  }

  return (
    <div className="blog-list">
      <div className="blog-list-grid">
        {posts.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default BlogList;

